import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import useGetLocumJobs from '../hooks/dashboard/jobs/useGetLocumJobs';

interface JobSearchContextType {
  keyword: string;
  setKeyword: (v: string) => void;
  payInterval: string;
  setPayInterval: (v: string) => void;
  location: string;
  setLocation: (v: string) => void;
  page: string;
  setPage: (v: string) => void;
  perPage: string;
  setPerPage: (v: string) => void;
  loading: boolean;
}

const JobSearchContext = createContext<JobSearchContextType>({
  keyword: '',
  setKeyword: () => {},
  payInterval: '',
  setPayInterval: () => {},
  location: '',
  setLocation: () => {},
  page: '1',
  setPage: () => {},
  perPage: '10',
  setPerPage: () => {},
  loading: false,
});

export const JobSearchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { getLocumJobs: fetchJobs, loading } = useGetLocumJobs();

  const [keyword, setKeyword] = useState<string>('');
  const [payInterval, setPayInterval] = useState<string>('');
  const [location, setLocation] = useState<string>('');
  const [page, setPage] = useState<string>('1');
  const [perPage, setPerPage] = useState<string>('10');

  // 🔥 whenever ANY of these change, run the fetch with the *latest* values
  useEffect(() => {
    fetchJobs({ keyword, payInterval, location, page, perPage });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, payInterval, location, page, perPage]);

  return (
    <JobSearchContext.Provider
      value={{
        keyword,
        setKeyword,
        payInterval,
        setPayInterval,
        location,
        setLocation,
        page,
        setPage,
        perPage,
        setPerPage,
        loading,
      }}
    >
      {children}
    </JobSearchContext.Provider>
  );
};

export const useJobSearch = () => useContext(JobSearchContext);
